module.exports = __webpack_public_path__ + "img/gatorz-support.8400290d.png";